import { render, staticRenderFns } from "./LandingBabyNeeds.vue?vue&type=template&id=66e2f2ea"
import script from "./LandingBabyNeeds.vue?vue&type=script&lang=js"
export * from "./LandingBabyNeeds.vue?vue&type=script&lang=js"
import style0 from "./LandingBabyNeeds.vue?vue&type=style&index=0&id=66e2f2ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports